import axios from "../api/api";

const deleteProduct = async (id) => {
  const response = await axios.delete(`/product?id=${id}`, {
    headers: {
      "Content-Type": "text/plain",
      Accept: "application/json, text/plain, */*",
    },
  });

  return response;
};

export default deleteProduct;
